import React, { useState, useRef } from 'react';
import './OtpInput.css';
import { isEmpty } from '../../utils/common';


const OtpInput = ({type,otp=['','','',''],setOtp=() =>{},isDisable=false,placeholder=""}) => {
  const inputRefs = useRef([]);

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]*$/.test(value) && value.length <= 1) {
      const updatedOtp = [...otp];
      updatedOtp[index] = value;
      setOtp(updatedOtp);

      // Focus on the next input field
        
      if (value !== '' && index < (otp.length - 1)) {
        inputRefs.current[index + 1].focus();
      
      }else if(isEmpty(value) && index > 0 ){
        
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const onfocusInput  = (e) =>{
 e.target?.children[0]?.focus()
  }

  return (
    <div className="otp-input flex">
      {otp.map((digit, index) => (
        <div className='box' key={index} onClick={onfocusInput}>
          <input
          key={index}
          type={type}
          placeholder={placeholder}
          disabled={isDisable}
          value={digit}
          onChange={(e) => handleOtpChange(e, index)}
          maxLength="1"
          ref={(input) => (inputRefs.current[index] = input)}
        />
        </div>
      ))}
    </div>
  );
};

export default OtpInput;
